import { AsyncState, Fun } from 'widgets-for-react'
import { OverviewOptions } from '../../overview_state'
import { SearchAndTagFilterLayout } from './tags_filter_block'
import {Map} from 'immutable'
import { TagTitle, TagValues } from '../../../../types.mod'
import { PageKind } from '../../overview_page'
export type RenderFilterBlock = (page_kind: PageKind, args: FilterBlockArgs) => JSX.Element

export type FilterBlockArgs = {
  // industryTags: string[]
  // typeTags: string[]
  tags: Map<TagTitle, TagValues>,
  options: OverviewOptions
  filterTagChanged: (tags:Map<TagTitle, TagValues>, searchQuery?: string) => void
  searchQueryChanged: (searchQuery: string) => void
  searchSubmitted: () => void
}

export const renderArticlesFilter = (page_kind: PageKind, args: FilterBlockArgs): JSX.Element => {
  return SearchAndTagFilterLayout(page_kind, args)
}